export default __webpack_public_path__ + "static/media/WarAlert.6a5afc07.svg";